import { useEffect } from 'react';
export var ZendeskEmbed = function ZendeskEmbed(props) {
  useEffect(function () {
    if (window.innerWidth > 768 && !(props !== null && props !== void 0 && props.hideEmbed)) {
      var script = document.createElement('script');
      script.src = 'https://static.zdassets.com/ekr/snippet.js?key=37ba59db-79c8-4fb0-8988-5ec7b5e766ee';
      script.id = 'ze-snippet';
      document.body.appendChild(script);
    }
  }, []);
  return null;
};